export const ATLAS_SERVER_URL = process.env.REACT_APP_ATLAS_SERVER_URL!
